export const textFields = {
  default: {
    flex: 1,
    pb: 4,
    '& .textfield-container': {
      position: 'relative'
    },
    '& .textfield-label': {
      fontWeight: 'medium',
      fontSize: 'body',
      lineHeight: 'body',
      '&.error': {
        color: 'state.error'
      },
      display: 'block'
    },
    '& .textfield-input': {
      fontWeight: 'regular',
      fontSize: 'body',
      lineHeight: 'body',
      mt: 2,
      px: 4,
      py: 3,
      borderRadius: 0,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '&.error': {
        border: 'boldError'
      }
    },
    '& .textfield-input::placeholder': {
      fontWeight: 'regular',
      fontSize: 'body',
      lineHeight: 'body'
    },
    '& .textfield-error': {
      bg: 'state.error',
      color: 'white',
      width: '100%',
      display: 'block',
      p: 2,
      mt: 2,
      position: 'relative',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: '-8px',
        left: '20px',
        width: 0,
        height: 0,
        pt: '1px',
        borderLeft: '8px solid transparent',
        borderRight: '8px solid transparent',
        borderBottom: '8px solid',
        borderBottomColor: 'state.error'
      }
    }
  }
}

export type TextFieldVariants = `textFields.${keyof typeof textFields}`
